import { render } from "./BuildModel.vue?vue&type=template&id=05fa8114"
import script from "./BuildModel.vue?vue&type=script&lang=js"
export * from "./BuildModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__